import { en } from './locales/en';
import { de } from './locales/de';
import { es } from './locales/es';
import { fr } from './locales/fr';
import { it } from './locales/it';
import { pt } from './locales/pt';
import { el } from './locales/el';
import { tr } from './locales/tr';
import { ru } from './locales/ru';
import { ro } from './locales/ro';
import { zh } from './locales/zh';
import { ja } from './locales/ja';
import { id } from './locales/id';
import { hi } from './locales/hi';
import { ko } from './locales/ko';
import { sr } from './locales/sr';
import { bg } from './locales/bg';
import { hu } from './locales/hu';
import { pl } from './locales/pl';
import { cs } from './locales/cs';
import { da } from './locales/da';
import { sv } from './locales/sv';
import { no } from './locales/no';
import { nl } from './locales/nl';

export type Language = 'en' | 'de' | 'es' | 'fr' | 'it' | 'pt' | 'el' | 'tr' | 'ru' | 'ro' | 'zh' | 'ja' | 'id' | 'hi' | 'ko' | 'sr' | 'bg' | 'hu' | 'pl' | 'cs' | 'da' | 'sv' | 'no' | 'nl';

export const dictionaries: Record<Language, Record<string, string>> = {
    en, de, es, fr, it, pt, el, tr, ru, ro, zh, ja, id, hi, ko, sr, bg, hu, pl, cs, da, sv, no, nl
};
